import { type ZodType } from 'zod';

import { ContractError } from './errors.js';

/**
 * The one place a response becomes a typed value.
 *
 * Every module's queries pass their payload through here, which is what makes
 * the Zod schema the source of truth for a shape rather than a second
 * description of a hand-written interface. Types come from `z.infer`, so the
 * schema and the type cannot disagree.
 *
 * `safeParse`, not `parse`: the thrown error must name the endpoint. A bare
 * ZodError in a log says a string was expected somewhere, which is the least
 * useful half of the information.
 */
export function parseOrThrow<TSchema extends ZodType>(
  schema: TSchema,
  value: unknown,
  endpoint: string,
): TSchema['_output'] {
  const result = schema.safeParse(value);
  if (result.success) return result.data;
  throw new ContractError(endpoint, result.error);
}
